import paymentsBackendEpicClient from 'bundles/epic/clients/__generated__/payments-backend';
import type CartsV2 from 'bundles/naptimejs/resources/carts.v2';
import PaymentProcessorTypes from 'bundles/payments-common/common/PaymentProcessorTypes';
import type { PaymentProcessorType } from 'bundles/payments-common/common/PaymentProcessorTypes';

export const STRIPE_PAYMENT_PROCESSOR_TYPES: ReadonlyArray<PaymentProcessorType> = [
  PaymentProcessorTypes.stripeConsumer,
  PaymentProcessorTypes.stripeConsumerSandbox,
  PaymentProcessorTypes.stripeBvConsumer,
  PaymentProcessorTypes.stripeBvConsumerSandbox,
];

export const isStripeBillingEngineRazorpayEnabled = () =>
  paymentsBackendEpicClient.get('enableStripeBillingEngineRazorpayWithRetries');

export const isStripeBillingEngineRazorpayEnabledPreview = (cart: CartsV2) =>
  (cart.isCourseraPlusSubscription || cart.isSpecializationSubscription) &&
  paymentsBackendEpicClient.preview('enableStripeBillingEngineRazorpayWithRetries');

const defaultPaymentMethodConfiguration = {
  stripeBvConsumer: 'pmc_1PC76EAEXNY2zYJrBbgPAPqB',
  stripeBvConsumerSandbox: 'pmc_1OyfCuAEXNY2zYJrm0Lbt9Fv',
  stripeConsumerSandbox: 'pmc_1PC3SwBEfO1jc2fnBE9wxPjn',
  stripeConsumer: 'pmc_1PqdhUBEfO1jc2fn2Y31iEKB',
};

export const isKlarnaEnabled = () => {
  return (
    paymentsBackendEpicClient.preview('stripeSubscriptionPaymentMethodConfig').stripeConsumer !==
    defaultPaymentMethodConfiguration.stripeConsumer
  );
};

export const isPixEnabled = (cart: CartsV2) => {
  return cart.isVC && cart.currencyCode === 'BRL' && paymentsBackendEpicClient.preview('enablePIX');
};

export const getStripePaymentMethodConfiguration = (isSandboxEnabled?: boolean, isRouteToStripeBv?: boolean) => {
  const paymentMethodConfiguration =
    paymentsBackendEpicClient.preview('stripeSubscriptionPaymentMethodConfig') || defaultPaymentMethodConfiguration;
  if (isRouteToStripeBv) {
    return isSandboxEnabled
      ? paymentMethodConfiguration.stripeBvConsumerSandbox
      : paymentMethodConfiguration.stripeBvConsumer;
  } else {
    return isSandboxEnabled
      ? paymentMethodConfiguration.stripeConsumerSandbox
      : paymentMethodConfiguration.stripeConsumer;
  }
};

// TODO: Delete this function when Stripe is fully rolled out
// https://coursera.atlassian.net/browse/PAYPLAT-3089
export const isNonUpsellCourse = (cart: CartsV2) => {
  // Courses with promo discount applied won't be exactly $49 for the $49 course -> $49 C+ upsell
  // BRL has geo pricing, only R$282 course is eligible for upsell
  // Also Guided Projects and Projects don't trigger course upsell
  return (
    cart.hasDiscount ||
    cart.isForGuidedProject ||
    cart.isForSelfPacedProject ||
    (cart.currencyCode === 'BRL' && cart.totalAmount !== 282)
  );
};

export const getIsCourseUpsellOnStripeEligible = (cart: CartsV2) => {
  return cart.isVC && !cart.hasDiscount && !cart.isForGuidedProject && !cart.isForSelfPacedProject;
};
